export default function ReelIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.25 7C21.5931 7 20.25 8.34315 20.25 10V14C20.25 15.6569 21.5931 17 23.25 17V18L23.0439 17.9951C20.9306 17.8879 19.25 16.14 19.25 14V10C19.25 7.79086 21.0409 6 23.25 6V7Z"
          fill="white"
        />
        <path
          d="M1 7C2.65685 7 4 8.34315 4 10V14C4 15.6569 2.65685 17 1 17V18L1.20605 17.9951C3.31944 17.8879 5 16.14 5 14V10C5 7.79086 3.20914 6 1 6V7Z"
          fill="white"
        />
        <path
          d="M12.6123 3C13.5721 3 14.2675 3.88149 14.084 4.79199L14.0352 4.97461L12.8965 8.3916C12.6223 9.21342 11.5301 9.30401 11.1016 8.60938L11.0244 8.45996L9.61524 5.07715C9.20356 4.08912 9.92963 3 11 3H12.6123ZM11 4C10.6432 4 10.4009 4.36306 10.5381 4.69238L11.9482 8.0752L13.0869 4.6582L13.1035 4.59766C13.1649 4.29408 12.9323 4 12.6123 4H11Z"
          fill="white"
        />
        <path
          d="M14 6C16.2091 6 18 7.79086 18 10V14C18 16.2091 16.2091 18 14 18H10L9.79395 17.9951C7.68056 17.8879 6 16.14 6 14V10C6 7.79086 7.79086 6 10 6H11V7H10C8.34315 7 7 8.34315 7 10V14C7 15.6569 8.34315 17 10 17H14C15.6569 17 17 15.6569 17 14V10C17 8.34315 15.6569 7 14 7H13V6H14Z"
          fill="white"
        />
      </svg>
    </>
  );
}
